module.exports = __webpack_public_path__ + "img/small_businesses_top_banner.b6fa4048.png";